export default __webpack_public_path__ + "static/media/721613989115-2.1192887a.png";